import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    ChartOptions,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip);

const SemiCircleChart: React.FC = () => {
    const data = {
        labels: ["Remaining", "Used"],
        datasets: [
            {
                data: [100, 0],
                backgroundColor: ["#A020F0", "#E5C9FA"], // tím đậm, tím nhạt
                borderWidth: 0,
                cutout: "75%", // ✅ giảm cutout xuống để vòng mảnh hơn (80% bán kính là phần rỗng)
                rotation: 270, // bắt đầu từ dưới
                circumference: 180, // nửa vòng tròn
            },
        ],
    };

    const options: ChartOptions<"doughnut"> = {
        responsive: true,
        maintainAspectRatio: false, // ✅ giữ đúng tỷ lệ 260x130
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
                backgroundColor: "#fff",
                titleColor: "#000",
                bodyColor: "#000",
                borderColor: "#ddd",
                borderWidth: 1,
                padding: 8,
                displayColors: false,
            },
        },
    };

    const colors = ["#A020F0", "#E5C9FA"];

    return (
        <>
            <div
                style={{
                    width: 260,
                    height: 130, // ✅ nửa vòng tròn
                    margin: "0 auto",
                    textAlign: "center",
                    position: "relative",
                }}
            >
                {/* Chart */}
                <Doughnut data={data} options={options} />

                {/* Legend tuỳ chỉnh */}
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 20,
                    marginTop: 20,
                    marginBottom: 20
                }}
            >
                {data.labels.map((label, i) => (
                    <div
                        key={label}
                        style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                        <span
                            style={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                background: colors[i],
                            }}
                        />
                        <span style={{ fontSize: 13, color: "#555" }}>{label}</span>
                    </div>
                ))}
            </div>
        </>
    );
};

export default SemiCircleChart;
